
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticProps, GetStaticPropsContext } from 'next';
import styled from 'styled-components';
import { Account } from 'shared/api/accounts';
import { Review } from 'shared/api/latestReviews';
import Page from 'shared/components/Page';
import { getVipAccountIds } from 'shared/components/Vip/vipConfigs';
import useTranslation from 'shared/hooks/useTranslation';
import getReviews from 'lib/cache/latestReviews/reviews';
import getVipAccounts from 'lib/cache/vipAccounts/vipAccounts';
import HeaderSection from 'modules/sellsPage/v2/HeaderSection';
import { Description, Header, sectionStyles, StyledH1 } from 'modules/sellsPage/v2/Styled';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import Image from 'next/image';
const MainContent = styled.div `
  overflow: hidden;
  position: relative;

  @media ${({ theme }) => theme.DEVICE.XL} {
    overflow: unset;
  }
`;
const Section = styled.section `
  ${sectionStyles}
  max-width: 180rem;
`;
const ContentContainer = styled.div `
  align-items: center;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 2.4rem;

  @media ${({ theme }) => theme.DEVICE.XL} {
    margin: 0 auto;
  }
`;
interface ImageContainerProps {
    maxWidth: number;
}
const ImageContainer = styled.div<ImageContainerProps> `
  margin: 0 auto;

  @media ${({ theme }) => theme.DEVICE.XL} {
    width: 100%;
    transform: translateX(0);
    height: auto;
  }

  max-width: ${({ maxWidth }) => `${maxWidth}px`};
`;
const MultiLanguage = dynamic(() => import('modules/sellsPage/v2/crossborderSales/multiLanguageSection'));
const FindOutMore = dynamic(() => import('modules/sellsPage/v2/components/FindOutMore'));
const Vip = dynamic(() => import('shared/components/Vip-v2'));
type CrossbordersalesProps = {
    latestReviews: Review[];
    vipAccounts: Account[];
};
function Crossbordersales({ latestReviews, vipAccounts }: CrossbordersalesProps): JSX.Element {
    const { t, lang } = useTranslation('reviewTranslatePage');
    return (<Page reviews={latestReviews} withFooter withLatestReviews>
      <Head>
        {process.env.NEXT_PUBLIC_APP_ENV === 'prod' ? (<script>
            {`
              (function(h,o,t,j,a,r){
                h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                h._hjSettings={hjid:2707955,hjsv:6};
                a=o.getElementsByTagName('head')[0];
                r=o.createElement('script');r.async=1;
                r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                a.appendChild(r);
                })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
              `}
          </script>) : null}
        <title>{t('crossborderSales.titleTag')}</title>
      </Head>
      <main>
        <Section>
          <MainContent>
            <ContentContainer>
              <Header>
                <StyledH1>
                  <span>Hello, Hola, Salut!</span>&nbsp;
                  {t('crossborderSales.reviews')}
                </StyledH1>
              </Header>
              <Description>{t('crossborderSales.description')}</Description>
            </ContentContainer>
            <ImageContainer maxWidth={1583}>
              <Image width={1583} height={644} src={`/img/review-translate/v2/${lang === 'pl' ? 'pl' : 'en'}/hero-img.png`} alt="trustmate reviews" quality="100" priority layout="responsive"/>
            </ImageContainer>
          </MainContent>
        </Section>
        <MultiLanguage />
        <FindOutMore />
        <Vip accounts={vipAccounts}>
          <HeaderSection header={t('vip.customerImplementations', 'common')} description={t('vip.customerInterviews', 'common')}/>
        </Vip>
      </main>
    </Page>);
}
const getStaticProps: GetStaticProps<CrossbordersalesProps> = async (context: GetStaticPropsContext) => {
    const latestReviews = await getReviews({
        language: context.locale as string,
    });
    const vipAccounts = await getVipAccounts({
        allowedAccounts: getVipAccountIds(),
        sort: 'id',
        order: 'ASC',
    });
    return {
        props: { latestReviews, vipAccounts },
        revalidate: 60,
    };
};
export default Crossbordersales;

    async function __Next_Translate__getStaticProps__197e4b1fd1a__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/crossborder-sales',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__197e4b1fd1a__ as getStaticProps }
  